import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AddressEditorComponent } from "./address-editor.component";
import { ReactiveFormsModule } from "@angular/forms";
import { IMaskModule } from "angular-imask";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { TranslocoCoreModule } from "@i18n";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

@NgModule({
    declarations: [AddressEditorComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IMaskModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatOptionModule,
        MatSelectModule,
        NgxMatSelectSearchModule,

        // i18n
        TranslocoCoreModule,
    ],
    exports: [AddressEditorComponent],
})
export class AddressEditorModule {}
